import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'ew-credit-payment',
  templateUrl: './credit-payment.component.html',
  styleUrls: ['./credit-payment.component.scss'],
})
export class CreditPaymentComponent {
  success: boolean = false;
  loading: boolean = true;

  constructor(
    private API: ApiService,
    private MD: MatDialogRef<CreditPaymentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      paymentId: string;
      currencyAccountId: string;
      amount: string;
      currency: string;
      url?: string;
    },
  ) {}

  /**
   * send to credit payment
   * @author Martin Batun Tec.
   */
  send(): void {
    this.API.post(
      this.data.url
        ? this.data.url
        : `v1/company-currency-accounts/${this.data.currencyAccountId}/credit/`,
      {
        paymentRequestIds: [this.data.paymentId],
        invoiceFundsId: this.data.paymentId,
      },
    ).subscribe(
      (data: any) => {
        this.loading = false;
        this.success = true;
        this.MD.close(true);
        this.API.alertService.success('creditPayment:messageSuccess');
      },
      () => {
        this.loading = false;
        this.success = false;
      },
    );
  }
}
